import { render, staticRenderFns } from "./ItemRontottStrand.vue?vue&type=template&id=ca2a769e&scoped=true&"
import script from "./ItemRontottStrand.vue?vue&type=script&lang=js&"
export * from "./ItemRontottStrand.vue?vue&type=script&lang=js&"
import style0 from "./ItemRontottStrand.vue?vue&type=style&index=0&id=ca2a769e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2a769e",
  null
  
)

export default component.exports